<template>
  <el-card shadow="never">
    <el-form :model="endereco" ref="endereco" label-position="top">
      <el-row :gutter="12">
        <!-- CEP -->
        <el-col :span="12">
          <el-form-item 
            prop="cep"
            :rules="[{ required: true, message: 'CEP é obrigatório' }]"
          >
              <label>CEP</label>
              <div class="el-input">
                <input
                  class="el-input__inner" 
                  v-model="endereco.cep" 
                  v-mask="['#####-###']" 
                  placeholder="74000-000"
                  @keyup="preencherByCep"
                />
              </div>
          </el-form-item>
        </el-col>

        <!-- Logradouro -->
        <el-col :span="12">
            <el-form-item prop="logradouro">
                <label>Logradouro</label>
                <el-input 
                    v-model="endereco.logradouro" 
                    placeholder="Rua 20"
                    @keyup="dispatchInput"
                />
            </el-form-item>
        </el-col>

        <!-- Complemento -->
        <el-col :span="12">
          <el-form-item prop="logradouro">
              <label>Complemento</label>
              <el-input 
                  v-model="endereco.complemento" 
                  placeholder="Próx.a ..."
                  @keyup="dispatchInput"
              />
          </el-form-item>
        </el-col>

        <!-- Bairro -->
        <el-col :span="12" class="mb-3">
            <el-form-item prop="bairro">
              <label>Bairro</label>
              <el-input 
                  v-model="endereco.bairro" 
                  placeholder="Setor Central"
                  @keyup="dispatchInput"
              />
            </el-form-item>
        </el-col>

        <!-- Estado -->
        <el-col :span="12" class="mb-3">
          <div class="form-group">
            <label for="">Estado</label>
            <select name="" id="" class="form-control" @change="changeEstado" v-model="endereco.estado" disabled>
              <option value="0">Selecione o Estado</option>
              <option value="AC">Acre</option>
              <option value="AL">Alagoas</option>
              <option value="AP">Amapá</option>
              <option value="AM">Amazonas</option>
              <option value="BA">Bahia</option>
              <option value="CE">Ceará</option>
              <option value="DF">Distrito Federal</option>
              <option value="ES">Espirito Santo</option>
              <option value="GO">Goiás</option>
              <option value="MA">Maranhão</option>
              <option value="MT">Mato Grosso</option>
              <option value="MS">Mato Grosso do Sul</option>
              <option value="MG">Minas Gerais</option>
              <option value="PA">Pará</option>
              <option value="PB">Paraíba</option>
              <option value="PR">Paraná</option>
              <option value="PE">Pernambuco</option>
              <option value="PI">Piauí</option>
              <option value="RJ">Rio de Janeiro</option>
              <option value="RN">Rio Grande do Norte</option>
              <option value="RS">Rio Grande do Sul</option>
              <option value="RO">Rondônia</option>
              <option value="RR">Roraima</option>
              <option value="SC">Santa Catarina</option>
              <option value="SP">São Paulo</option>
              <option value="SE">Sergipe</option>
              <option value="TO">Tocantins</option>
            </select>
          </div>
        </el-col>

        <!-- Cidade -->
        <el-col :span="12">
          <div class="form-group">
            <label for="">Cidade</label>
            <select name="" id="" class="form-control" v-model="endereco.cidade" disabled>
              <option value="0">Selecione a Cidade</option>
              <option :value="cidade.ibge" v-for="cidade, i in cidades" :key="i">
                {{ cidade.nome }}
              </option>
            </select>
          </div>
        </el-col>
        
        <!-- Instrucoes -->
        <el-col :span="24" class="mb-3">
          <div class="form-group">
            <label for="">Instrução de Entrega</label>
            <textarea name="" id="" cols="30" rows="5" class="form-control" v-model="endereco.instrucao_entrega" @keyup="dispatchInput"></textarea>        
          </div>
        </el-col>
      </el-row>
     </el-form>
  </el-card>
</template>

<script>  
  // Components
  import { Card, Row, Col } from 'element-ui'
  import { Button, Form, FormItem, Input, Notification, Select, Option  } from "element-ui"
  // Utils
  import { cepViaCEP, cepBrasilApi } from "./../util/BuscaCep";

  export default {
    props: {
      value: {
        type: Object,
        required: true,
        default: function () {
          return {
            cep: "",
            logradouro: "",
            bairro: "",
            complemento: "",
            instrucao_entrega:"",
            cidade: 0, //IBGE
            estado: 0,
            ibge: null,
            import: null,
          };
        },
      },
    },
    data() {
      return {
        endereco: {
          cep: "",
          logradouro: "",
          bairro: "",
          complemento: "",
          instrucao_entrega:"",
          cidade: "0",
          estado: 0,
          ibge: null,
        },
        cidades: [],
      };
    },
    methods: {
      init() {
        if (typeof this.value.cep === "string") {
          this.endereco.cep = this.value.cep;
        }
        if (typeof this.value.logradouro === "string") {
          this.endereco.logradouro = this.value.logradouro;
        }
        if (typeof this.value.bairro === "string") {
          this.endereco.bairro = this.value.bairro;
        }
        if (typeof this.value.complemento === "string") {
          this.endereco.complemento = this.value.complemento;
        }
        if (typeof this.value.instrucao_entrega === "string") {
          this.endereco.instrucao_entrega = this.value.instrucao_entrega;
        }      
        if (typeof this.value.cidade === "string") {
          this.endereco.cidade = this.value.cidade;
        }
        if (typeof this.value.estado === "string") {
          this.endereco.estado = this.value.estado;
        }
        this.buscarCidades();
      },
      async preencherByCep() {
        if (this.endereco.cep.length != 9 && !this.value.import)  return;

        // Validando CEP - viaCEP
        try {
          const resViaCEP = await this.cepViaCEP(this.endereco.cep);
          
          if (resViaCEP != null) {
            this.endereco.logradouro = resViaCEP.logradouro;
            this.endereco.complemento = resViaCEP.complemento;
            this.endereco.estado = resViaCEP.uf;
            this.endereco.bairro = resViaCEP.bairro;

            this.buscarCidades();

            this.endereco.cidade = resViaCEP.ibge;
            
            this.dispatchInput();
            this.$emit("prazos", [resViaCEP.ibge, resViaCEP.uf]);
            
            return [resViaCEP.ibge, resViaCEP.uf];
          }

          const resCepBrasilApi = await this.cepBrasilApi(this.endereco.cep);
          if (resCepBrasilApi != null) {
            this.endereco.logradouro = resCepBrasilApi.street;
            this.endereco.estado = resCepBrasilApi.state;
            this.endereco.bairro = resCepBrasilApi.neighborhood;

            this.buscarCidades();

            this.endereco.cidade = resCepBrasilApi.ibge.city;
            
            this.dispatchInput();
            this.$emit("prazos", [resCepBrasilApi.ibge.city, resCepBrasilApi.state]);

            return [resCepBrasilApi.ibge.city, resCepBrasilApi.state];
          }

          throw new Error('O CEP informado não é válido ou é um CEP geral!');
        } catch (err) {
          this.$alert(err.message, 'Aviso', {
            confirmButtonText: 'Ok',
            type: 'warning'
          })
        }

        this.endereco.logradouro = "";
        this.endereco.complemento = "";
        this.endereco.instrucao_entrega ="";
        this.endereco.estado = 0;
        this.endereco.bairro = "";
        this.cidades = [];
        this.endereco.cidade = 0;
        this.dispatchInput();
      },

      changeEstado() {
        this.buscarCidades();
        this.endereco.cidade = 0;
      },
      buscarCidades() {
        if (this.endereco.estado == 0) {
          return;
        }

        var vm = this;
        $(".loading").show();
        axios
          .get("/cidades/" + this.endereco.estado)
          .then(function (response) {
            vm.cidades = response.data;
            $(".loading").hide();
          })
          .catch(function (error) {
            $(".loading").hide();

            Notification.error({
              title: 'Erro',
              message: 'Não foi possível carregar as Cidades. Algo inesperado ocorreu!'
            })
          });
      },
      isValid() {
        if (
          this.endereco.cep.length != 9 ||
          this.endereco.logradouro.length < 4 ||
          this.endereco.bairro.length == 0 ||
          this.endereco.estado == 0 ||
          this.endereco.cidade == 0
        ) {
          return false;
        }
        return true;
      },
      dispatchInput() {
        this.$emit("input", this.endereco);
      },
      cepViaCEP,
      cepBrasilApi
    },
    watch: {
      value(newValue, oldValue) {
        if (newValue) {
          this.endereco = newValue
          this.buscarCidades()
        }
      },
    },
    mounted() {
      if (this.value && this.value.import) {
        this.endereco.cep = String(this.value.cep);
        this.preencherByCep();
      } else if (this.value.cep) {
        this.endereco = {
          cep: this.value.cep,
          logradouro: this.value.logradouro,
          complemento: this.value.complemento,
          instrucao_entrega : this.instrucao_entrega,
          bairro: this.value.bairro,
          cidade: this.value.nome_cidade,
          estado: this.value.estado,
          ibge: this.value.cidade_ibge,
        }
      }
    },
    components: {
      [Card.name]: Card,
      [Row.name]: Row,
      [Col.name]: Col,
      [Button.name]: Button,
      [Form.name]: Form,
      [FormItem.name]: FormItem,
      [Input.name]: Input,
      [Select.name]: Select,
      [Option.name]: Option,
      Notification
    }
  };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/util/Endereco.vue